module.exports = __webpack_public_path__ + "static/media/19_A.18b942cf.png";